import React from 'react';
import {
    View,
    Text,
    TouchableOpacity,
    TextInput,
    Alert,
    FlatList,
    Image,
    ScrollView,
    ActivityIndicator, RefreshControl
} from 'react-native';
import { connect } from 'react-redux';
import IAppState from "../Models/App/IAppState";

import {AnyAction} from "redux";


import {StackNavigationProp} from "@react-navigation/stack";
import { RouteProp } from '@react-navigation/native';
import AppText from "../Components/AppText";
import HideableView from "../Components/HideableView";
import {DrawerNavigationProp} from "@react-navigation/drawer";
import ClientItem from "../Components/ClientItem";
import CourierItem from "../Components/CourierItem";
import IUser from "../Models/User/IUser";
import HttpRequest from "../utils/HttpRequest";
import IOrder from "../Models/IOrder";
import OpenedOrderItem from "../Components/OpenedOrderItem";
import {saveCouriers, saveOpenedOrders, saveOrderHistory} from "../Models/Courier/CourierActions";
import ConfirmionModal from "../Components/ConfirmionModal";
import DateTimePickerModal from "../Components/DateTimePickerModal";
import FilterableInput from "../Components/FilterableInput";
import IClient from "../Models/Client/IClient";
import ICourier from "../Models/Courier/ICourier";
import {saveClients} from "../Models/Client/ClientActions";

type navProps = DrawerNavigationProp< any, 'Clients'>;
interface IProps {
    navigation:navProps;
    user?:IUser
    saveOrderHistory:(orders:IOrder[])=>AnyAction
    orderHistory:IOrder[];
    clients:IClient[];
    couriers:ICourier[];
    saveCouriers:(couriers:ICourier[])=>AnyAction
    saveClients:(clients:IClient[])=>AnyAction
}
interface IState {
    isAddOpened:boolean;
    orders:IOrder[];
    fetching:boolean;
    confirmText:string;
    showConfirm:boolean;
    orderToRemove?:IOrder
    isSearching:boolean,
    selectedDate:Date;
    isDateModalShowing:boolean;
    selectedClientId:number;
    selectedCourierId:number;
}

class OrderHistory extends React.Component<IProps> {

    state:IState={
        isAddOpened:false,
        orders:[],
        fetching:false,
        confirmText:'',
        showConfirm:false,
        isSearching:false,
        selectedDate:new Date(),
        isDateModalShowing:false,
        selectedClientId:-1,
        selectedCourierId:-1
    }
    focusListiner:any=null;
    componentDidMount() {

       this.focusListiner= this.props.navigation.addListener('focus',this.getData)
    }
    componentWillUnmount() {
        if(this.focusListiner){
            this.focusListiner()
        }
    }

    getData=()=>{
        if(this.props.couriers.length==0 ){
            this.fetchCouriers()
        }
        if(this.props.clients.length==0){
            this.fetchClients();
        }
        if(this.props.user ){
            this.fetchData(this.props.user.CourierId)
        }
    }
    fetchCouriers(){
        this.setState({fetching:true})
        HttpRequest('couriers',"GET").then((result)=>{
            this.props.saveCouriers(result.data);
            this.setState({couriers:result.data})
        }).catch(e=>{

        }).finally(()=>this.setState({fetching:false}))
    }
    fetchClients(){
        this.setState({fetching:true})
        HttpRequest('clients',"GET").then((result)=>{
            this.props.saveClients(result.data)
            this.setState({clients:result.data})

        }).catch(e=>{

        }).finally(()=>this.setState({fetching:false}))
    }
    fetchData(courierId?:number){
        this.setState({fetching:true})
        HttpRequest('couriers/ordersHistory?id='+courierId+"&date="+this.state.selectedDate.toISOString(),'GET').then((result)=>{
            this.props.saveOrderHistory(result.data)
        }).catch(e=>{
            Alert.alert(JSON.stringify(e))
            console.log(e)
        }).finally(()=>this.setState({fetching:false}))
    }
    refresh(){
        if(this.props.user ){
            this.fetchData(this.props.user.CourierId)
        }
    }
    selectOrderToRemove(order:IOrder){
        let text='האם את רוצה למחוק את ההזמנה של '+order.Client?.businessName+ "?";
        this.setState({orderToRemove:order,showConfirm:true,confirmText:text})
    }
    removeSubOrder(orderId:number,subOrderId:number){
        let orders=this.props.orderHistory;
        for(let i=0;i<orders.length;i++){
            if(orders[i].id==orderId){
                let subOrders=orders[i].SubOrders;
                subOrders=subOrders.filter((s)=>s.id!=subOrderId);
                orders[i].SubOrders=subOrders;

            }
        }
    }
    removeOrder(){
        let orderToRemove=this.state.orderToRemove;
        this.setState({showConfirm:false})
        if(orderToRemove && orderToRemove.id){
            let orderId=orderToRemove.id;
            let orders=this.props.orderHistory;
            orders=orders.filter((o)=>o.id!=orderId)
            this.props.saveOrderHistory(orders)
            HttpRequest('orders','DELETE',{id:orderId}).then((result)=>{

            }).catch(e=>{

            })
        }
    }
    setDate(date:Date){
        this.setState({selectedDate:date},()=>{
            if(this.props.user ){
                this.fetchData(this.props.user.CourierId)
            }
        })

    }
    selectClient(id:number){
        this.setState({selectedClientId:id})
    }
    selectCourier(id:number){
        this.setState({selectedCourierId:id})

    }
    filterOrders(){
        let data=this.props.orderHistory;
        if(this.state.selectedClientId!=-1 && this.state.isSearching){
            data=data.filter(o=>o.ClientId==this.state.selectedClientId);
        }
        if(this.state.selectedCourierId!=-1 && this.state.isSearching){
            for(let i=0;i<data.length;i++){
                data[i].SubOrders= data[i].SubOrders.filter(so=>so.CourierId==this.state.selectedCourierId)
            }
            data=data.filter(o=>o.SubOrders.length!=0)
        }
        return data;
    }
    renderCountOrders(){
        const orders = this.filterOrders();
        if(!orders || (orders && orders.length == 0)){
            return <View/>
        }
        const orderCount = orders.length;
        let subOrdersCount = 0;
        orders.forEach(x=>{
            if(x.SubOrders){
                subOrdersCount += x.SubOrders.length;
            }
        })
        return <Text>סה׳כ הזמנות:{orderCount} סה׳כ תת הזמנות: {subOrdersCount}</Text>
    }
    render() {
        const data:any[]=[
            {name:'מוהנד עבד אלהדי',area:'צפון',phone:'052-1234567',licenseType:'B'}
        ]
        return(
            <View style={{width:'100%',height:'100%'}}>
                <View style={{width:'100%',flexDirection:'column',backgroundColor:'white',alignItems:'center',paddingLeft:0,paddingTop:15,zIndex:100}}>
                    <TouchableOpacity style={{width:'60%',height:30,justifyContent:'center',alignItems:'flex-start',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,paddingLeft:10,paddingRight:10}} onPress={()=>{
                        this.setState({isDateModalShowing:true})

                    }}>
                        <AppText style={{fontSize:13,color:'black'}}>{this.state.selectedDate.toISOString().substring(0,10)}</AppText>
                    </TouchableOpacity>

                   <View style={{width:'60%',marginTop:5,zIndex:200}}>
                       <FilterableInput  openCallBack={(isOpened:boolean)=>this.setState({isScrollDisabled:isOpened})} onValueChange={(val:number)=>this.selectClient(val)} width={'100%'} placeholder={'שם הלקוח'} options={this.props.clients.map(c=>{
                           return {label:c.businessName,value:c.id}
                       })}/>
                   </View>
                    <View style={{width:'60%',marginTop:5,zIndex:150}}>
                        <FilterableInput openCallBack={(isOpened:boolean)=>this.setState({isScrollDisabled:isOpened})} onValueChange={(val:number)=>this.selectCourier(val)} width={'100%'} placeholder={'שם השליח'} options={this.props.couriers.map(c=>{
                            return {label:c.name,value:c.id}
                        })}/>
                    </View>
                    <TouchableOpacity onPress={()=>this.setState({isSearching:!this.state.isSearching})} style={{width:100,marginTop:10,marginBottom:10,height:25,backgroundColor:'#019FB2',marginLeft:10,justifyContent:'center',alignItems:'center',borderRadius:25}}>
                        <AppText style={{color:'#fff',fontWeight:'700'}}>{this.state.isSearching?'ביטול':'חיפוש'}</AppText>
                    </TouchableOpacity>
                    {this.renderCountOrders()}
                </View>
                <ScrollView   refreshControl={<RefreshControl refreshing={this.state.fetching} onRefresh={()=>this.refresh()} />} style={{display:'flex',flexDirection:'column',backgroundColor:'white',flex:1,width:'100%',paddingTop:0}}>
                    <FlatList

                        data={this.filterOrders()}
                        ListHeaderComponent={()=><View style={{height:30,width:'100%',backgroundColor:'#373737',paddingLeft:15,paddingRight:15,flexDirection:'row',alignItems:'center'}}>
                            <View style={{flex:0.23,alignItems:'flex-start'}}>
                                <AppText style={{color:'white'}}>שם המזמין</AppText>
                            </View>
                            <View style={{flex:0.34,alignItems:'flex-start'}}>
                                <AppText style={{color:'white'}}>כתובת</AppText>
                            </View>
                            <View style={{flex:0.23,alignItems:'flex-start'}}>
                                <AppText style={{color:'white'}}>טלפון</AppText>
                            </View>
                            <View style={{flex:0.2,alignItems:'flex-start'}}>

                            </View>
                        </View>}
                        renderItem={({ item }) =><OpenedOrderItem removeSubOrderCallBack={(orderId:number,subOrderId:number)=>this.removeSubOrder(orderId,subOrderId)} onLongPress={(item:IOrder)=>this.selectOrderToRemove(item)} order={item}/> }
                    />
                    <ConfirmionModal confirmCallBack={()=>this.removeOrder()} closeCallBack={()=>this.setState({showConfirm:false})} text={this.state.confirmText} show={this.state.showConfirm}/>
                    <DateTimePickerModal closeCallBack={()=>this.setState({isDateModalShowing:false})} onChange={(val:any)=>this.setDate(val)} mode={'date'} show={this.state.isDateModalShowing} />

                </ScrollView>

            </View>
        );
    }
}
const mapStateToProps = (state:IAppState) => {
    //Alert.alert(JSON.stringify(state))
    return {
        user:state.user.current,
        orderHistory:state.courier.orderHistory,
        clients:state.client.clients,
        couriers:state.courier.couriers
    };
};

const mapDispatchToProps ={
    saveOrderHistory:saveOrderHistory,
    saveCouriers:saveCouriers,
    saveClients:saveClients
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderHistory);
